export default "__VITE_ASSET__CQriPEzz__"